import { AxiosError, AxiosResponse } from 'axios';
import Vue, { PropType, VNode } from 'vue';

Vue.component('msp-api-error', {
  props: {
    response: [Error, Object],
  },

  render(createElement): VNode {
    if (!this.response) {
      return createElement('');
    }

    const { response, message } = this.response as AxiosError;

    if (response?.data.error !== 'ValidationException') {
      return createElement('div', response?.data?.message ?? message);
    }

    const errors = Object.keys(response?.data ?? {})
      .reduce((values, key) => values.concat(response?.data?.[key]), [])
      .filter(e => !!e);

    return createElement('div', errors[0]);
  },
});
